var e4 = e4 || {},
    identity = identity || {};

identity.stockValidation = {
    _checkoutLoaded: null,
    _cartData: null,
    init: function () {
        identity.stockValidation.bindEvents();
    },
    bindEvents: function () {
        jQuery('.js-e-cart').on('updated.e4.cart', function (event, jsonData) {
            identity.stockValidation.onUpdated(jsonData);
        });
        jQuery('.js-e-checkout').on('cartupdated.e4.checkout', function (event, jsonData) {
            identity.stockValidation.onUpdated(jsonData);
        });
    },
    onUpdated: function (jsonData) {
        if (jsonData.cart.orderlinesOverStock.length > 0) {
            jQuery('.js-identity-cart-stock-alert').removeClass('d-none');
            jQuery('.js-e-checkout-btn').addClass('disable-checkout-btn');
        } else {
            jQuery('.js-identity-cart-stock-alert').addClass('d-none');
            jQuery('.js-e-checkout-btn').removeClass('disable-checkout-btn');
        }
    }
};
identity.cart = {
    init: function () {
        identity.cart.bindEvents();
    },
    bindEvents: function () {
        jQuery('.js-e-cart').on('click', '.js-e-apply-voucher-code', function () {
            identity.cart.applyVoucher();
        });
    },
    applyVoucher: function () {
        var jVoucherCode = jQuery('.js-e-voucher-code').val();

        if (jVoucherCode) {
            var jVoucherCodeInput = jQuery('input[name="EcomOrderVoucherCode"]');
            jVoucherCodeInput.val(jVoucherCode);
            var jForm = jVoucherCodeInput.closest('.js-e-cart-form');
            e4.cart.ajax({
                data: jForm.serialize()
            }, function (jsonData) {
                //console.log('yessir');
            });
        }
    }
};
identity.checkout = {
    init: function () {
        var jDibsCheckout = jQuery('#dibs-complete-checkout');
        if (jDibsCheckout.length > 0) {
            var objDibsData = jDibsCheckout.data();
            e4.require.js({
                url: objDibsData.checkoutSrc,
                fallback: objDibsData.checkoutSrc,
                callback: function () {
                    if (objDibsData.key && objDibsData.paymentId) {
                        var objCheckoutOptions = {
                                checkoutKey: objDibsData.key,
                                paymentId: objDibsData.paymentId,
                                containerId: 'dibs-complete-checkout',
                                language: 'da-DK'
                            },
                            checkout = new Dibs.Checkout(objCheckoutOptions);
                        checkout.on('payment-completed', function (response) {
                            var url = objDibsData.invoiceApproveUrl,
                                invoicePaymentId = response.paymentId;
                            if (url && invoicePaymentId) {
                                window.location = url + '&paymentId=' + invoicePaymentId;
                            }
                        });
                    }
                }
            });
        }
    }
};
identity.ecom = {
    init: function () {
        const jProduct = jQuery('.js-e-product');
        identity.ecom.descriptionCollapse();
        identity.ecom.listItemVariantImageHover();
        identity.ecom.variants.init();
        identity.ecom.zoom.init();
        identity.ecom.video.init();
        identity.ecom.swiper.init();
        if (jProduct.length === 1) {
            identity.productDataPdf.init();
            identity.ecom.specifications.init();
        }
        if (jQuery('.js-e-product-matrix-modal').length > 0) {
            identity.ecom.matrix.init();
        } else if (jQuery('.js-e-productlist, .js-e-search-modal, .js-relewise-search, .js-e-cart').length > 0) {
            identity.ecom.matrix.bindEvents();
        }
    },
    listItemVariantImageHover: function () {
        var _baseImage,
            _timeout,
            _wait = 200,
            strOptionColorSelector = '.js-identity-variant-listitem-select-option-color';
        jQuery(document).on('mouseover', strOptionColorSelector, function (event) {
            var strMouseOverImage = jQuery(event.target).data('hoverImage'),
                jMainImage = jQuery(event.target).closest('.js-e-productlist-item').find('.js-e-productlist-item-image');
            _baseImage = jMainImage;
            jMainImage.attr('src', strMouseOverImage);
            if (_timeout) {
                clearTimeout(_timeout);
            }
        }).on('mouseout', strOptionColorSelector, function () {
            _timeout = setTimeout(function () {
                if (_baseImage) {
                    _baseImage.attr('src', _baseImage.data('baseImage'));
                }
            }, _wait);
        });
    },
    descriptionCollapse: function () {
        var jTruncate = jQuery('.js-identity-product-description-truncated');
        if (jTruncate.length === 1) {
            var jCollapse = jQuery('.js-identity-product-text').find('.collapse');
            jCollapse.height('auto');
            jCollapse.on('show.bs.collapse', function () {
                jTruncate.html(jTruncate.data('fullText'));
            }).on('hide.bs.collapse', function () {
                jTruncate.html(jTruncate.data('partialText'));
            }).on('hidden.bs.collapse', function () {
                jCollapse.height('auto');
            });
        }
    },
    specifications: {
        init: () =>{
            identity.ecom.specifications.tabs
            identity.ecom.specifications.bindEvents();
            identity.ecom.specifications.setActiveText();
        },
        bindEvents: () =>{
            jQuery(document).on('click', '.js-toggle-mobile-specifications', (event) =>{
                const target = event.currentTarget.dataset.target;
                jQuery(target).toggleClass('show');
            }).on('click', '[data-toggle="tab"]', (event) =>{
                identity.ecom.specifications.setActiveText();
            });
        },
        setActiveText: () =>{
            const specDropdownBtn = jQuery('.js-toggle-mobile-specifications-text');
            const tabs = document.getElementById('identity-specifications-navigation');

            if(tabs !== null){
                tabs.querySelectorAll('[data-toggle="tab"]').forEach((tabToggle) => {
                    tabToggle.style.pointerEvents = '';
                })
            }
            
            
            if(identity.ecom.specifications.isMobile()){
                const activeTab = identity.ecom.specifications.getActiveTab();
                if(activeTab !== null){
                    specDropdownBtn.text(activeTab.textContent);
                    activeTab.style.pointerEvents = 'none';
                }
                if(tabs !== null){
                    tabs.classList.remove('show');
                }
                
            }
        },
        getActiveTab: () =>{
            const tabs = document.getElementById('identity-specifications-navigation');
            if(tabs !== null){
                return tabs.querySelector('[data-toggle="tab"].active');
            }
            return null;
            
        },
        isMobile: () =>{
            const jDropdownBtn = jQuery('.js-toggle-mobile-specifications');
            return jDropdownBtn.length > 0 && jDropdownBtn.is(':visible');
            
        }
    },
    swiper: {
        _instance: null,
        settings:{
            desktop:{
                freeMode: {
                    enabled: false
                },
                direction: 'vertical',
                scrollbar: {
                    enabled: false
                },
                mousewheel: {
                    enabled: true,
                    releaseOnEdges: true
                },
            },
            mobile:{
                freeMode: {
                    enabled: false
                },
                direction: 'horizontal',
                scrollbar: {
                    enabled: true
                },
                mousewheel: {
                    enabled: false
                },
            }
        },
        init: () =>{
            if(document.querySelector('.js-identity-swiper') !== null){
                identity.ecom.swiper.requireStyle();
                identity.ecom.swiper.enable();
                
            }
        },
        enable: () =>{
            if(document.querySelector('.js-identity-swiper') === null){
                return false;
            }
            identity.ecom.swiper._instance = new Swiper('.js-identity-swiper', {
                slidesPerView: 'auto',
                spaceBetween: 0,
                zoom:{
                    enabled: true
                },
                scrollbar: {
                    el: '.swiper-scrollbar'
                },
                breakpoints: {
                    320: identity.ecom.swiper.settings.mobile,
                    640: identity.ecom.swiper.settings.desktop
                },
                on: {
                    slideChange: (swiper) => {
                        setTimeout(function () {
                            swiper.params.mousewheel.releaseOnEdges = false;
                        }, 250);
                        
                        const currentSlide = swiper.slides[swiper.activeIndex];
                        const previousSlide = swiper.slides[swiper.previousIndex];
                        const currentVideo = currentSlide.querySelector('video');
                        const previousVideo = previousSlide.querySelector('video');
                        if(currentVideo && !currentVideo.playing){
                            currentVideo.play();
                        }
                        if(previousVideo && previousVideo.playing){
                            previousVideo.pause();
                        }
                        
                        
                    },
                    reachEnd: (swiper) => {
                        setTimeout(function () {
                            swiper.params.mousewheel.releaseOnEdges = true;
                        }, 500);
                    },
                    reachBeginning: (swiper) => {
                        setTimeout(function () {
                            swiper.params.mousewheel.releaseOnEdges = true;
                        }, 500);
                    }
                }
            });
        },
        requireStyle: () =>{
            const url = '/Files/Templates/Designs/identity_v2/_assets/_dist/css/swiper.css';
            const link = document.createElement('link');
            const mainStyle = document.head.querySelector('#identity-main-style');
            link.rel = 'stylesheet';
            link.href = url;
            mainStyle.before(link)
        }
    },
    video: {
        init: function () {
            identity.ecom.video.bindEvents();
        },
        bindEvents: function () {
            jQuery('.js-e-product-images, .js-e-product-images-modal').on('mouseover', '.js-carousel-indicator, .js-identity-video-thumb', function (event) {
                var strContainer = jQuery(event.currentTarget).data('target'),
                    jVideo = jQuery(strContainer).find('.js-identity-video-in-carousel');
                if (jVideo.length === 1) {
                    var domVideo = jVideo.get(0);
                    if (jQuery(event.currentTarget).is('.js-identity-video-thumb') === true) {
                        domVideo.play();
                    } else {
                        domVideo.pause();
                    }
                }
            }).on('slid.bs.carousel', function (event) {
                if (jQuery(event.relatedTarget).is('.js-identity-video-item') === true) {
                    var jVideo = jQuery(event.relatedTarget).find('.js-identity-video-in-carousel');
                    jVideo.get(0).play();
                }
            });
        }
    },
    zoom: {
        defaults: {
            zoomLevel: 1.2,
            zoomStep: 0.1,
            maxZoomLevel: 2,
            minZoomLevel: 1
        },
        init: function () {
            identity.ecom.zoom.bindEvents();
        },
        bindEvents: function () {
            jQuery('.js-e-product-modal-images').on('mouseover mousemove', '.js-identity-product-zoom', function (event) {
                identity.ecom.zoom.style.set(event.currentTarget, event);
            }).on('mouseleave mouseout', function (event) {
                identity.ecom.zoom.style.reset(event.target);
            }).on('wheel', '.js-identity-product-zoom', function (event) {
                if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
                    identity.ecom.zoom.level.set(identity.ecom.zoom.defaults.zoomStep);
                } else {
                    identity.ecom.zoom.level.set(-(identity.ecom.zoom.defaults.zoomStep));
                }
                identity.ecom.zoom.style.set(event.currentTarget, event);
            });
        },
        level: {
            get: function () {
                var intZoomLevel = identity.ecom.zoom.defaults.zoomLevel;
                if (identity.ecom.zoom._zoomLevel) {
                    intZoomLevel = identity.ecom.zoom._zoomLevel;
                }
                return intZoomLevel;
            },
            set: function (intLevel) {
                var intCurrentLevel = identity.ecom.zoom.level.get(),
                    intNextLevel = intCurrentLevel + intLevel;
                if (intNextLevel > identity.ecom.zoom.defaults.maxZoomLevel) {
                    intNextLevel = identity.ecom.zoom.defaults.maxZoomLevel;
                } else if (intNextLevel < identity.ecom.zoom.defaults.minZoomLevel) {
                    intNextLevel = identity.ecom.zoom.defaults.minZoomLevel;
                }
                identity.ecom.zoom._zoomLevel = intNextLevel;
            }
        },
        style: {
            get: function (domElm, event) {
                var objBounds = domElm.getBoundingClientRect(),
                    intZoomLevel = identity.ecom.zoom.level.get(),
                    strPositionLeft = (event.pageX - objBounds.left) / (objBounds.width) * 100 + '%',
                    strPositionTop = (event.pageY - objBounds.top) / (objBounds.height) * 100 + '%',
                    strSize = 100 * intZoomLevel + '%';
                if (intZoomLevel === identity.ecom.zoom.defaults.minZoomLevel) {
                    strPositionLeft = 'cover';
                    strPositionTop = 'cover';
                    strSize = 'contain';
                }
                return {
                    backgroundPositionX: strPositionLeft,
                    backgroundPositionY: strPositionTop,
                    backgroundSize: strSize,
                    cursor: 'zoom-in'
                };
            },
            set: function (domElm, event) {
                var objZoomedStyle = identity.ecom.zoom.style.get(domElm, event);
                jQuery(domElm).css(objZoomedStyle);
            },
            reset: function (domElm) {
                jQuery(domElm).css({
                    backgroundPositionX: '',
                    backgroundPositionY: '',
                    backgroundSize: '',
                    cursor: ''
                });
                identity.ecom.zoom._zoomLevel = identity.ecom.zoom.defaults.zoomLevel;
            }
        }
    },
    matrix: {
        constants: {
            variantColorGroup: '',
            designQuantity: 10
        },
        selectedListModal: null,
        activeTab: null,
        activeInputIndex: null,
        tabDirection: 'next',
        isDesignerMatrixValid: true,
        init: function () {
            identity.ecom.matrix.constants.variantColorGroup = jQuery('.js-e-product-matrix-form').data('variantGroupColorName');
            e4.require.js(e4.settings.require.handlebars, function () {
                e4.handlebars.registerTemplates('#js-e-handlebars-tmpl-product-matrix-cart');
                identity.ecom.matrix.bindEvents();
                identity.ecom.matrix.calculateTotalQuantityPerColor();
                
            });
        },
        bindEvents: function () {
            jQuery(document).on('submit', '.js-e-product-matrix-form', function (event) {
                event.preventDefault();
                identity.ecom.matrix.addToCart(event.target);
            }).on('click', '.js-e-product-matrix-quantity-increase', function (event) {
                identity.ecom.matrix.changeQuanity(event.target, 'increase');
            }).on('click', '.js-e-product-matrix-quantity-decrease', function (event) {
                identity.ecom.matrix.changeQuanity(event.target, 'decrease');
            }).on('show.bs.modal', '.js-e-product-matrix-modal', function (event) {
                
                var selectedVariantId = jQuery('.js-e-product-matrix-modal').data('selectedVariant'),
                    jTabToActivate = jQuery(event.target).find('.js-e-product-matrix-options-colors-nav-link[data-variant-id="' + selectedVariantId + '"]');
                
                if (selectedVariantId !== undefined) {
                    jTabToActivate.tab('show');
                } else {
                    jQuery(event.target).find('.js-e-product-matrix-options-colors-nav-link').first().tab('show');
                }
                jQuery('[data-toggle="tooltip"]').tooltip();
                identity.ecom.matrix.validateDesignerQuantity();
                
            }).on('show.bs.tab', '.js-e-product-matrix-options-colors-option', function (event) {
                var variantId = event.target.dataset.variantId,
                    jForm = jQuery('.js-e-product-form');
                
                if (variantId !== undefined && jForm.length > 0) {
                    jForm.find('.js-e-product-form-variant-group-input[value="' + variantId + '"]').prop('checked', true).trigger('change');
                }
                
                var colorOption = jQuery(event.target).find('.e-product-matrix-options-colors-option-label'),
                    variantMatrixBackgroundImageSrc = colorOption.css('background-image'),
                    variantMatrixColorName = colorOption.data('color');
                jQuery('.js-e-product-matrix-modal-image').css('background-image', variantMatrixBackgroundImageSrc);
                jQuery('.js-identity-selected-color-variant-text').text(variantMatrixColorName);
            }).on('shown.bs.tab', '.js-e-product-matrix-options-colors-option', function (event) {
                identity.ecom.matrix.activeTab = event.target.hash;
                identity.ecom.matrix.focusQuantityInputInPane();
                
            }).on('input', '.js-e-product-matrix-quantity',  e4.util.debounce(function (event) {
                const max = parseInt(event.target.max);
                const value = parseInt(event.target.value);
                const jStockErrorElement = jQuery(event.target).closest('.js-e-product-matrix-size-row').find('.js-e-product-matrix-stock-error');
                if(value > max){
                    event.target.classList.add('is-invalid');
                    jStockErrorElement.removeClass('d-none');
                    jQuery('.js-e-product-matrix-add-to-cart-btn').prop('disabled', true);
                    return false;
                } else{
                    event.target.classList.remove('is-invalid');
                    jStockErrorElement.addClass('d-none');
                }
                
                identity.ecom.matrix.calculateTotalPrice(event.target);
                identity.ecom.matrix.calculateTotalQuantityPerColor(event.target);
                identity.ecom.matrix.calculateTotalPricePerSize(event.target);
                identity.ecom.matrix.validateDesignerQuantity();
            }, e4.settings.debounceDelay.input)).on('keydown', '.js-e-product-matrix-quantity', function (event) {
                var keyCode = event.keyCode;

                if (keyCode === 107 || keyCode === 39) { // Increase quantity => Plus / ArrowRight
                    event.preventDefault();
                    identity.ecom.matrix.changeQuanity(event.target, 'increase');
                } else if (keyCode === 109 || keyCode === 37) { // Decrease quantity => Minus / ArrowLeft
                    event.preventDefault();
                    identity.ecom.matrix.changeQuanity(event.target, 'decrease');
                } else if ((event.shiftKey === false && keyCode === 9) || keyCode === 40) { // Next input or tab => Tab / ArrowDown
                    identity.ecom.matrix.tabNext(event, true);
                } else if ((event.shiftKey === true && keyCode === 9) || keyCode === 38) { // Prev input or tab =>  Shift+Tab / ArrowUp
                    identity.ecom.matrix.tabPrev(event, true);
                } else if ((event.shiftKey === false && keyCode === 32) || keyCode === 34) { // Next tab => Space / PageDown
                    identity.ecom.matrix.tabNext(event, false);
                } else if ((event.shiftKey === true && keyCode === 32) || keyCode === 33) { // Prev tab => Shift+Space / PageUp
                    identity.ecom.matrix.tabPrev(event, false);
                } else if ((event.shiftKey === false && keyCode === 13)) { // Prevent Form Submit => Enter
                    event.preventDefault();
                } else if ((event.shiftKey === true && keyCode === 13)) { // Add to cart => Shift+Enter
                    jQuery(event.target).closest('.js-e-product-matrix-form').triggerHandler('submit');
                }

            }).on('focus', '.js-e-product-matrix-quantity', function (event) {
                event.target.select();
            });
            
            jQuery('.js-e-productlist, .js-e-search-modal, .js-relewise-search, .js-e-cart').on('click', '.js-identity-productlist-get-variant-matrix-modal', function (event) {
                event.preventDefault();
                identity.ecom.matrix.productlist.getModal(event.currentTarget).then(function (strHtml) {
                    identity.ecom.matrix.productlist.appendAndOpenMatrix(event.currentTarget, event.delegateTarget, strHtml);
                });
            });
            jQuery('.js-toggle-matrix-modal-btn-customershop').on('click', (event) =>{
                event.preventDefault();
                var objProductData = jQuery('.js-identity-customershop-matrix-modal-placeholder').data();

                jQuery.ajax({
                    url: e4.settings.ecom.matrixModal.url,
                    data: objProductData
                }).then((strHtml) =>{
                    var jContainer = jQuery('.js-e-product'),
                        jListnerElement = jContainer;

                    jContainer.append(strHtml);

                    jListnerElement.find('.js-e-product-matrix-modal').on('hidden.bs.modal', function (event) {
                        jQuery(event.target).remove();
                    }).modal('show');
                });
            });
        },
        productlist: {
            _cache: {},
            getModal: function (domBtn) {
                var jListItem = jQuery(domBtn).closest('.js-e-productlist-item');
                var jOrderLine = jQuery(domBtn).closest('.js-e-orderline');
                var objProductData =  null;
                
                if(jListItem.length){
                    objProductData = jListItem.data();
                } else if(jOrderLine.length){
                    objProductData = jOrderLine.data();
                    objProductData.isCart = true;
                }
                
                var cachedRequest = objProductData ? identity.ecom.matrix.productlist._cache[objProductData.productId + '.' + objProductData.variantId] : undefined;
                
                if (cachedRequest !== undefined && jQuery('html').data('state') !== 'CustomerShop') {
                    return cachedRequest;
                }
                var xhr = jQuery.ajax({
                    url: e4.settings.ecom.matrixModal.url,
                    data: objProductData,
                    beforeSend: function () {
                        if(jListItem){
                            jListItem.find('.js-e-matrix-loading-overlay').addClass('is-loading');
                        }
                    }
                });
                identity.ecom.matrix.productlist._cache[objProductData.productId + '.' + objProductData.variantId] = xhr;
                return xhr;
            },
            appendAndOpenMatrix: function (domBtn, domContainer, strHtml) {
                var jContainer = jQuery(domContainer),
                    jListenerElement = jContainer;
                jQuery(domBtn).closest('.js-e-productlist-item').find('.js-e-matrix-loading-overlay').removeClass('is-loading');
                let modalOptions = 'show';
                if (jContainer.is('.js-e-search-modal') === true || jContainer.is('.js-relewise-search') === true) {
                    jListenerElement = jQuery('body');
                    jListenerElement.append(strHtml);
                } else {
                    jContainer.append(strHtml);
                }
                
                if(jContainer.is('.js-relewise-search') === true){
                    modalOptions = {
                        backdrop: false
                    };
                }

                jListenerElement.find('.js-e-product-matrix-modal').on('hidden.bs.modal', function (event) {
                    jQuery(event.target).remove();
                }).modal(modalOptions);
            }
        },
        changeQuanity: function (domBtn, strAction) {
            var jQuantity = jQuery(domBtn).closest('.js-e-product-matrix-quantity-group').find('.js-e-product-matrix-quantity'),
                intQuantity = jQuantity.val() !== '' ? parseInt(jQuantity.val()) : 0;
            if (strAction === 'increase') {
                intQuantity++;
            } else if (strAction === 'decrease' && intQuantity > 0) {
                intQuantity--;
            }
            jQuantity.val(intQuantity).trigger('input');
        },
        focusQuantityInputInPane: function () {
            setTimeout(function () {
                if (identity.ecom.matrix.activeInputIndex !== null) {
                    var inputByIndex = jQuery(identity.ecom.matrix.activeTab).find('.js-e-product-matrix-quantity').eq(identity.ecom.matrix.activeInputIndex);
                    if (inputByIndex.is(':disabled') === false) {
                        inputByIndex.focus();
                        identity.ecom.matrix.activeInputIndex = null;
                    } else {
                        identity.ecom.matrix.activeInputIndex++;
                        identity.ecom.matrix.focusQuantityInputInPane();
                    }
                } else {
                    if (identity.ecom.matrix.tabDirection === 'next') {
                        jQuery(identity.ecom.matrix.activeTab).find('.js-e-product-matrix-quantity:not(:disabled)').first().focus();
                    } else {
                        jQuery(identity.ecom.matrix.activeTab).find('.js-e-product-matrix-quantity:not(:disabled)').last().focus();
                    }
                }


            }, 100);
        },
        tabNext: function (event, boolFocusNextInput) {
            var jModal = jQuery(event.target).closest('.js-e-product-matrix-modal'),
                jRow = jQuery(event.target).closest('.js-e-product-matrix-size-row'),
                hasNextRow = jRow.nextAll('.js-e-product-matrix-size-row:not(.disabled)').length > 0;

            identity.ecom.matrix.tabDirection = 'next';

            if (boolFocusNextInput === false) {
                identity.ecom.matrix.activeInputIndex = jQuery('.js-e-product-matrix-quantity').filter(':focus').closest('.js-e-product-matrix-size-row').index() - 1;
            }

            if (hasNextRow === false || boolFocusNextInput === false) {
                event.preventDefault();
                var jActiveNavLink = jModal.find('.js-e-product-matrix-options-colors-nav-link.active').closest('li'),
                    jFirstNavLink = jModal.find('.js-e-product-matrix-options-colors-nav-link').first();
                if (jActiveNavLink.next('li').length > 0) {
                    jActiveNavLink.next('li').find('a').tab('show');
                } else {
                    jFirstNavLink.tab('show');
                }
            } else {
                if (event.keyCode !== 9) {
                    jRow.next('.js-e-product-matrix-size-row').find('.js-e-product-matrix-quantity').focus();
                }
            }
        },
        tabPrev: function (event, boolFocusPrevInput) {
            var jModal = jQuery(event.target).closest('.js-e-product-matrix-modal'),
                jRow = jQuery(event.target).closest('.js-e-product-matrix-size-row'),
                hasPrevRow = jRow.prevAll('.js-e-product-matrix-size-row:not(.disabled)').length > 0;

            identity.ecom.matrix.tabDirection = 'prev';

            if (boolFocusPrevInput === false) {
                identity.ecom.matrix.activeInputIndex = jQuery('.js-e-product-matrix-quantity').filter(':focus').closest('.js-e-product-matrix-size-row').index() - 1;
            }

            if (hasPrevRow === false || boolFocusPrevInput === false) {
                event.preventDefault();
                var jActiveNavLink = jModal.find('.js-e-product-matrix-options-colors-nav-link.active').closest('li'),
                    jLastNavLink = jModal.find('.js-e-product-matrix-options-colors-nav-link').last();
                if (jActiveNavLink.prev('li').length > 0) {
                    jActiveNavLink.prev('li').find('a').tab('show');
                } else {
                    jLastNavLink.tab('show');
                }
            } else {
                if (event.keyCode !== 9) {
                    jRow.prev('.js-e-product-matrix-size-row').find('.js-e-product-matrix-quantity').focus();
                }

            }
        },
        calculateByMultiplePrices: function (jRow, intQuantity) {
            var returnPrice = 0;
            jRow.find('.js-variant-matrix-multiple-price').each(function (index, domElm) {
                var quantity = parseInt(domElm.dataset.quantity),
                    price = parseFloat(domElm.dataset.price);

                if (intQuantity >= quantity) {
                    returnPrice = price;
                }
            });
            return returnPrice;
        },
        calculateTotalPricePerSize: function (domInput) {
            var jSizeRow = jQuery(domInput).closest('.js-e-product-matrix-size-row'),
                floatPrice = e4.util.formatStringToJavascriptNumber(jQuery(domInput).data('price')),
                hasMultiplePrices = jQuery(domInput).data('multiplePrices') === 'True',
                intQuantity = domInput.value !== '' ? parseInt(domInput.value) : 0;

            if (hasMultiplePrices) {
                floatPrice = identity.ecom.matrix.calculateByMultiplePrices(jSizeRow, intQuantity);
            }
            var floatTotalPrice = floatPrice * intQuantity;

            jSizeRow.find('.js-total-size-row-price .e-price-price').html(e4.util.formatJavascriptNumberToLocaleString(floatTotalPrice));
        },
        calculateTotalPrice: function (domInput) {
            var jModal = jQuery(domInput).closest('.js-e-product-matrix-modal'),
                jQuantityInputs = jModal.find('.js-e-product-matrix-quantity'),
                intTotalPrice = 0;
            jQuantityInputs.each(function (index, domInput) {
                var hasMultiplePrices = jQuery(domInput).data('multiplePrices') === 'True',
                    jSizeRow = jQuery(domInput).closest('.js-e-product-matrix-size-row');
                if (domInput.value) {
                    var rowPrice = e4.util.formatStringToJavascriptNumber(domInput.dataset.price),
                        intQuantity = parseInt(domInput.value);
                    if (hasMultiplePrices === true) {
                        rowPrice = identity.ecom.matrix.calculateByMultiplePrices(jSizeRow, intQuantity);
                    }
                    var intRowPrice = intQuantity * rowPrice;
                    intTotalPrice += parseFloat(intRowPrice);
                }
            });
            jQuery('.js-e-product-matrix-total-price').find('.e-price-price').html(e4.util.formatJavascriptNumberToLocaleString(intTotalPrice));
        },
        validateDesignerQuantity: function(){
            const jDesignerForm = jQuery('.js-e-designer-matrix-form');
            if(jDesignerForm.length){
                const quantities = [];
                jDesignerForm.find('.js-e-product-matrix-quantity').each(function (_i, domElm) {
                    const value = parseInt(domElm.value);
                    if(value > 0){
                        quantities.push(value);
                    }
                    
                });
                const totalQuantity = quantities.reduce((accumulator, quantity) => {
                    return accumulator + quantity;
                }, 0);
                identity.ecom.matrix.isDesignerMatrixValid = totalQuantity >= identity.ecom.matrix.constants.designQuantity;
                
                if(identity.ecom.matrix.isDesignerMatrixValid){
                    jQuery('.js-e-product-matrix-add-to-cart-btn').prop('disabled', false);
                } else{
                    jQuery('.js-e-product-matrix-add-to-cart-btn').prop('disabled', true);
                }
            }
        },
        calculateTotalQuantityPerColor: function (domInput) {
            var jModal = jQuery(domInput).closest('.js-e-product-matrix-modal'),
                intTotalQuantity = 0;
            jModal.find('.js-e-product-matrix-options-colors-option').each(function (index, domElm) {
                var sizeId = domElm.dataset.id,
                    intTotalQuantityPerColor = 0,
                    jPane = jModal.find('.js-e-product-matrix-options-sizes-pane[id="' + sizeId + '"]');
                jPane.find('.js-e-product-matrix-quantity').each(function (jndex, domInput) {
                    if (domInput.value !== '') {
                        intTotalQuantityPerColor += parseInt(domInput.value);
                    }
                });
                intTotalQuantity += intTotalQuantityPerColor;
                var jFooterElement = jQuery('.js-matrix-selected-variants').find('.js-matrix-selected-variant-option[data-id="' + sizeId + '"]');
                if (intTotalQuantityPerColor > 0) {
                    jFooterElement.removeClass('d-none');
                } else {
                    jFooterElement.addClass('d-none');
                }
                jFooterElement.find('.js-e-product-matrix-total-quantity').text(intTotalQuantityPerColor);
            });
            jQuery('.js-e-product-matrix-add-to-cart-btn').prop('disabled', function () {
                const hasInvalids = jModal.find('.js-e-product-matrix-quantity.is-invalid').length > 0;
                return intTotalQuantity <= 0 || hasInvalids;
            });
        },
        updateDesignerCart: async (domForm, arrProducts, orderContext) =>{
            const formData = new FormData();
            formData.append('CartCmd', 'updateorderlines');
            formData.append('Redirect', 'false');
            formData.append('OrderContext', orderContext);
            arrProducts.forEach((productObj) => {
                formData.append(`QuantityOrderLine${productObj.orderLineId}`, productObj.quantity);
                formData.append(`EcomOrderLineFieldInput_QuoteProductDesignerDataOrderLine${productObj.orderLineId}`, productObj.data);
            });
            return await fetch(e4.settings.ecom.cart.url, {
                method: 'POST',
                body: formData
            })
        },
        addDesignerCart: async (domForm, arrProducts, orderContext) =>{
            const formData = new FormData();
            formData.append('CartCmd', 'addmulti');
            formData.append('Redirect', 'false');
            formData.append('OrderContext', orderContext);
            arrProducts.forEach((productObj) =>{
                if(productObj.quantity > 0){
                    formData.append(`ProductLoopCounter${productObj.loopCounter}`, productObj.loopCounter);
                    formData.append(`Quantity${productObj.loopCounter}`, productObj.quantity);
                    formData.append(`ProductID${productObj.loopCounter}`, productObj.productId);
                    formData.append(`VariantID${productObj.loopCounter}`, productObj.variantId);
                    formData.append(`EcomOrderLineFieldInput_QuoteProductDesignerData${productObj.loopCounter}`, productObj.data);
                    
                }
            });
            return await fetch(e4.settings.ecom.cart.url, {
                method: 'POST',
                body: formData
            })
        },
        addToCart: async (domForm) => {
            //var formDataArray = jQuery(domForm).serializeArray();
            //console.time('Add to Cart');
            
            if(Array.from(domForm.classList).includes('js-e-designer-matrix-form')){
                const designerData = document.querySelector('.js-designer-data')?.value;
                const orderContext = document.querySelector('.js-designer-context')?.value;
                const updateInputs = [];
                const addInputs = [];
                const formData = new FormData( domForm );
                const formDataEntries = [...formData.entries()];
                const loopCounters = formDataEntries.filter( i => i[0].startsWith( 'ProductLoopCounter' ) );

                loopCounters.forEach( ( loopCounter ) => {
                    const quantityInput = formDataEntries.filter( i => i[0].startsWith( 'Quantity' ) ).find( i => i[0] === `Quantity${ loopCounter[1] }` );
                    const quantityDomInput = domForm.querySelector(`input[name="${quantityInput[0]}"]`);
                    const productIdInput = formDataEntries.filter( i => i[0].startsWith( 'ProductID' ) ).find( i => i[0] === `ProductID${ loopCounter[1] }` );
                    const variantIdInput = formDataEntries.filter( i => i[0].startsWith( 'VariantID' ) ).find( i => i[0] === `VariantID${ loopCounter[1] }` );
                    
                    if(Array.from(quantityDomInput.classList).includes('js-designer-to-update')){
                        updateInputs.push({
                            orderLineId: quantityDomInput.dataset.orderlineId,
                            quantity: quantityDomInput.value,
                            data: designerData,
                        });
                    } else{
                        addInputs.push({
                            loopCounter: loopCounter[1],
                            productId: productIdInput[1],
                            variantId: variantIdInput[1],
                            data: designerData,
                            quantity: quantityDomInput.value
                        });
                    }
                });

                await identity.ecom.matrix.updateDesignerCart(domForm, updateInputs, orderContext);
                const request = await identity.ecom.matrix.addDesignerCart(domForm, addInputs, orderContext);
                const response = await request.json();
                
                console.log('response', response);
                e4.cart.updateContent(response);

                identity.ecom.matrix.reset();
                jQuery('.js-e-product-matrix-modal ').modal('hide');
                jQuery('.js-e-product-matrix-overlay').removeClass('is-loading');
                
            } else{
                jQuery.ajax({
                    url: e4.settings.ecom.cart.url,
                    method: 'POST',
                    dataType: 'json',
                    cache: false,
                    beforeSend: function () {
                        jQuery('.js-e-product-matrix-overlay').addClass('is-loading');
                    },
                    data: jQuery(domForm).serialize()
                }).done(function (jsonData) {
                    e4.cart.updateQuantityInfo(jsonData.cart);
                    identity.ecom.matrix.reset();
                    jQuery('.js-e-product-matrix-modal ').modal('hide');
                    jQuery('.js-e-product-matrix-overlay').removeClass('is-loading');
                });
            }
            
            
        },
        getFormDataProp: function (arrFormData, dataKey) {
            var returnValue = '';
            var objFoundProp = arrFormData.filter(function (fd) {
                return fd.name === dataKey;
            });
            if (objFoundProp.length > 0) {
                returnValue = objFoundProp[0].value;
            }
            return returnValue;

        },
        reset: function () {
            var jQuantityInputs = jQuery('.js-e-product-matrix-quantity'),
                jSizerowPrices = jQuery('.js-total-size-row-price');
            jQuantityInputs.each(function (index, domInput) {
                jQuery(domInput).val(0);
            });
            jSizerowPrices.each(function (index, domElm) {
                jQuery(domElm).find('.e-price-price').html(e4.util.formatJavascriptNumberToLocaleString(0));
            });
            jQuery('.js-e-product-matrix-total-quantity').text(0);
        }
    },
    variants: {
        _cache: {},
        init: function () {
            identity.ecom.variants.bindEvents();
            jQuery('[data-toggle="tooltip"]').tooltip();
        },
        xhr: function (objAjaxSettings) {
            var arrCacheKeys = [ e4.settings.ecom.variantCombinations.url ];
            if (jQuery.isPlainObject(objAjaxSettings.data) === true) {
                arrCacheKeys.push(jQuery.param(objAjaxSettings.data));
            }
            var strCacheKey = arrCacheKeys.join('?').replace(/\./g, '_');
            if (identity.ecom.variants._cache[strCacheKey] !== undefined) {
                return identity.ecom.variants._cache[strCacheKey];
            } else {
                var xhr = jQuery.ajax(jQuery.extend({
                    method: 'GET',
                    dataType: 'json',
                    url: e4.settings.ecom.variantCombinations.url,
                    cache: true
                }, objAjaxSettings));
                identity.ecom.variants._cache[strCacheKey] = identity.ecom.variants.xhrInstance;
                return xhr;
            }
        },
        bindEvents: function () {
            const jProduct = jQuery('.js-e-product');
            jProduct.on('loaded.e4.product.variants', (event, jsonData) =>{
                if (jsonData.product !== undefined) {
                    identity.ecom.variants.onVariantLoadAndChange(event, jsonData);
                }
            })
            jQuery('.js-identity-extra-variants-collapse').on('show.bs.collapse', function (event) {
                identity.ecom.variants.toggleHiddenVariants(event.target, true);
            }).on('hide.bs.collapse', function (event) {
                identity.ecom.variants.toggleHiddenVariants(event.target, false);
            });
        },
        disabledSizeVariantNotInStock: function () {
           
            var dataObj = jQuery('.js-e-product').data();
            dataObj.variantId = jQuery('.js-e-product-form-variant-group-input').map(function (index, domInput) {
                return domInput.checked ? domInput.value : null;
            }).toArray().join('.');



            if (jQuery('.js-e-product-matrix-modal').length === 0) {
                if (identity.ecom.variants.variantcomboXhr && identity.ecom.variants.variantcomboXhr.readyState !== 4) {
                    identity.ecom.variants.variantcomboXhr.abort();
                }
                identity.ecom.variants.variantcomboXhr = identity.ecom.variants.xhr({ data: dataObj });
                identity.ecom.variants.variantcomboXhr.done(function (jsonResponse) {

                    var intVariantCombinationsCount = 0,
                        intDisabledVariantCombinationsCount = 0,
                        tickNext = false;
                    jQuery.each(jsonResponse.variantCombinations, function (index, objCombo) {
                        var strSizeVariantId = objCombo.variantId.split('.')[1],
                            strColorVariantId = objCombo.variantId.split('.')[0],
                            jVariantInput = jQuery('.js-e-product-form-variant-group-input[value="' + strSizeVariantId + '"][data-name="' + objCombo.sizeVariantText.replace("\"", '') + '"]'),
                            isDisabled = objCombo.stock.quantity <= 0;
                        if (strColorVariantId === jQuery('.js-e-product-form-variant-group-input:checked').val()) {
                            intVariantCombinationsCount++;
                            jVariantInput.prop('disabled', isDisabled);
                            if (isDisabled === true) {
                                intDisabledVariantCombinationsCount++;

                                if(jVariantInput.prop('checked') === true){
                                    tickNext = true;
                                }
                            }
                            
                            if(jVariantInput.prop('disabled') === false && tickNext === true){
                                tickNext = false;
                                jVariantInput.prop('checked', true).trigger('change');
                            }
                        }
                    });
                    jQuery('.js-e-product-form-addtocart').find('button[type="submit"]').prop('disabled', intVariantCombinationsCount === intDisabledVariantCombinationsCount);
                });
            }
        },
        toggleHiddenVariants: function (domElm, boolIsOpen) {
            var jVariantGroup = jQuery(domElm).closest('.js-e-product-form-variant-form-group'),
                toggleBtn = jVariantGroup.find('.js-identity-variant-select-option'),
                extraVariantOption = jVariantGroup.find('.js-identity-variant-select-option-hidden');
            if (boolIsOpen === true) {
                toggleBtn.addClass('d-none');
                extraVariantOption.removeClass('d-none');
            } else {
                toggleBtn.removeClass('d-none');
                extraVariantOption.addClass('d-none');
            }
        },
        onVariantLoadAndChange: function (event, jsonData) {
            var jProduct = jQuery('.js-e-product'),
                jProductMatrix = jQuery('.js-e-product-matrix'),
                jCustomerShopElement = jQuery('.js-identity-customershop-matrix-modal-placeholder');

            if (jsonData.product) {

                jProduct.find('.js-identity-selected-color-variant-text').html(jsonData.product.colorVariantText);
                jProduct.data({
                    productId: jsonData.product.id,
                    variantId: jsonData.product.variantId
                });

                if (jQuery('.js-e-product-matrix-modal').length === 0) {
                    identity.ecom.variants.disabledSizeVariantNotInStock();
                } else{
                    jQuery('.js-e-product-matrix-modal').data('selectedVariant', jsonData.product.colorVariantId);
                    
                }
                if(identity.ecom.swiper._instance !== null){
                    identity.ecom.swiper._instance.destroy(true, true);
                }
                

                jQuery('.js-e-price').html(jsonData.product.price.formatted);
                jQuery('.js-id-no-number').html(jsonData.product.number);
                jQuery('.js-e-product-images').html(jsonData.imagesHtml);
                jQuery('.js-e-product-modal-images').html(jsonData.modelImagesHtml);
                jQuery('.js-identity-specifications-container').html(jsonData.specificationsHtml);
                jQuery('.js-identity-recommendations-container').html(jsonData.recommendationsHtml);

                identity.ecom.specifications.setActiveText();
                
                if(jCustomerShopElement.length){
                    jCustomerShopElement.data('productId', jsonData.product.id);
                    jCustomerShopElement.data('variantId', jsonData.product.variantId);
                }

                
                identity.ecom.swiper.enable();

                jProductMatrix.find('.js-e-product-matrix-options-sizes-pane').each(function (pindex, domTab) {
                    jQuery(domTab).find('.js-e-product-matrix-size-row').each(function (rindex, domRow) {
                        var variantSizeId = domRow.dataset.variantId,
                            jRow = jQuery(domRow);
                        if (variantSizeId !== undefined) {
                            var shouldDisabled = jRow.find('input').is('.js-e-product-matrix-quantity-disabled');
                            if (shouldDisabled) {
                                jRow.addClass('disabled').find('input').prop('disabled', true);
                            } else {
                                jRow.removeClass('disabled').find('input').prop('disabled', false);
                            }
                        }
                    });
                });
                jProductMatrix.find('.js-e-product-matrix-options-colors-nav-link').each(function (index, domTab) {
                    var variantId = domTab.dataset.variantId,
                        jActiveColorVariant = jQuery('.js-e-product-form-variant-group-input').filter(':checked');
                    if (variantId !== undefined) {
                        if (jQuery('.js-e-product-form-variant-group-input[value="' + variantId + '"]').prop('disabled') === true) {
                            jQuery(domTab).addClass('disabled');
                        } else {
                            jQuery(domTab).removeClass('disabled');
                        }
                        if (variantId === jActiveColorVariant.val()) {
                            jQuery(domTab).tab('show');
                            identity.ecom.matrix.focusQuantityInputInPane();
                        }
                    }
                });
            }

        }
    }
};